import React from "react";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Tooltip,
  Box,
} from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import {
  Dashboard as DashboardIcon,
  ShoppingCart as ShoppingCartIcon,
  Mail as MailIcon,
  People as PeopleIcon,
  Settings as SettingsIcon,
} from "@mui/icons-material";

const SidebarNavigation: React.FC = () => {
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  const getListItemStyles = (path: string) => ({
    backgroundColor: isActive(path) ? 'primary.main' : 'transparent',
    color: isActive(path) ? 'white' : 'inherit',
    '&:hover': {
      backgroundColor: isActive(path) ? 'primary.dark' : 'action.hover',
    },
    borderRadius: 1,
    mx: 1,
    mb: 0.5,
  });

  const getIconStyles = (path: string) => ({
    color: isActive(path) ? 'white' : 'inherit',
  });

  return (
    <div>
      <List>
        <ListItem
          button
          component={Link}
          to="/my-biz/my-listings"
          sx={getListItemStyles('/my-biz/my-listings')}
        >
          <ListItemIcon sx={getIconStyles('/my-biz/my-listings')}>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText primary="My Listings" />
        </ListItem>
        <ListItem
          button
          component={Link}
          to="/my-biz/orders"
          sx={getListItemStyles('/my-biz/orders')}
        >
          <ListItemIcon sx={getIconStyles('/my-biz/orders')}>
            <ShoppingCartIcon />
          </ListItemIcon>
          <ListItemText primary="Orders" />
        </ListItem>
        <ListItem
          button
          component={Link}
          to="/my-biz/my-connections"
          sx={getListItemStyles('/my-biz/my-connections')}
        >
          <ListItemIcon sx={getIconStyles('/my-biz/my-connections')}>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText primary="My Connections" />
        </ListItem>
        {/* Wrap the disabled ListItem in a Box with Tooltip */}
        <Tooltip title="Coming soon" arrow>
          <Box sx={{ display: "flex", alignItems: "center", cursor: "not-allowed" }}>
            <ListItem button disabled>
              <ListItemIcon>
                <ShoppingCartIcon />
              </ListItemIcon>
              <ListItemText primary="Purchases" />
            </ListItem>
          </Box>
        </Tooltip>
        {/* Wrap the disabled ListItem in a Box with Tooltip */}
        <Tooltip title="Coming soon" arrow>
          <Box sx={{ display: "flex", alignItems: "center", cursor: "not-allowed" }}>
            <ListItem button disabled>
              <ListItemIcon>
                <MailIcon />
              </ListItemIcon>
              <ListItemText primary="Inbox" />
            </ListItem>
          </Box>
        </Tooltip>
        {/* Wrap the disabled ListItem in a Box with Tooltip */}
        <Tooltip title="Coming soon" arrow>
          <Box sx={{ display: "flex", alignItems: "center", cursor: "not-allowed" }}>
            <ListItem button disabled>
              <ListItemIcon>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText primary="Settings" />
            </ListItem>
          </Box>
        </Tooltip>
      </List>
      <Divider />
    </div>
  );
};

export default SidebarNavigation;
